import React from 'react';
import { ButtonWithSecondaryThemeProvider } from 'src/components/shared/ButtonWithSecondaryThemeProvider';
import { useMediaQuery } from '@jarvis/react-portal-addons';
import { breakpoints } from 'src/constants/breakpoints';
import { DEEEPLINKS } from 'src/constants/deeplinks';
import * as S from './styles';

export const Buttons = ({
  change_printer_button_text,
  continue_button_text,
  back_button_text,
  currentIndex,
  stepsLength,
  platform,
  isHpx,
  isRTL
}: {
  change_printer_button_text: string;
  continue_button_text: string;
  back_button_text: string;
  currentIndex: number;
  stepsLength: number;
  platform: string;
  isHpx: boolean;
  isRTL: boolean;
}): React.ReactElement => {
  const searchParams = new URLSearchParams(window.location.search);
  const continueButtonURL =
    searchParams.get('primary') || 'hpsmart://reset/continue';
  const exitSetupURL = 'hpsmart://reset/back';
  const isListAvailable = searchParams.get('showChangeButton') === 'true';
  const isTabletAndMobile = useMediaQuery(
    `(max-width: ${breakpoints.bigtablet})`
  );

  const disableContinueButton = currentIndex !== stepsLength - 1;

  const renderFooterButton = () => {
    const text = continue_button_text || back_button_text;
    const id = continue_button_text ? 'continue-button' : 'exit-setup-button';
    const dataTestId = continue_button_text
      ? 'printer-connection-continue-button'
      : 'printer-connection-exit-button';
    const buttonUrl = continue_button_text ? continueButtonURL : exitSetupURL;

    return (
      <S.FooterButton
        isHpx={isHpx}
        id={id}
        data-testid={dataTestId}
        disabled={disableContinueButton}
        onClick={() => window.location.assign(buttonUrl)}
      >
        <S.FooterButtonText dangerouslySetInnerHTML={{ __html: text }} />
      </S.FooterButton>
    );
  };

  return (
    <S.Container
      isHpx={isHpx}
      isRTL={isRTL}
    >
      <ButtonWithSecondaryThemeProvider
        enableTheme={!isTabletAndMobile}
        id="change-printer-button"
        data-testid="printer-connection-change-printer-button"
        appearance={isTabletAndMobile ? 'ghost' : 'secondary'}
        onClick={() => {
          isListAvailable
            ? window.Shell.v1.navigation.goBack()
            : window.Shell.v1.navigation.push(
                `${DEEEPLINKS.SUPPORT_GENERIC}?platform=${platform}`
              );
        }}
      >
        <S.FooterButtonText
          dangerouslySetInnerHTML={{ __html: change_printer_button_text }}
        />
      </ButtonWithSecondaryThemeProvider>

      {renderFooterButton()}
    </S.Container>
  );
};
